import { render } from "./inspections.vue?vue&type=template&id=753a7caa"
import script from "./inspections.vue?vue&type=script&lang=js"
export * from "./inspections.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__